/** @file English catalog part of area E9 (W3-03); replaced whole by that area. */

/** The `psdImport` and `autorig` blocks (spread at the top level). S0 composes it into `en`. */
export const autorigPanelEn = {
  psdImport: {
    choosePsd: 'Import PSD…', choosePngs: 'Add PNG images…', newFromPsd: 'New project from PSD…',
    titlePsd: 'Import PSD layers', titlePng: 'Import PNG images', reading: 'Reading {file}…', projectName: 'Project name',
    layers: 'Layers, bottom to top', size: '{w} × {h} px at {x}, {y}', hidden: 'hidden in the PSD',
    place: 'Place the images (offsets in pixels from the top-left)', x: 'x', y: 'y', preview: 'Placement preview',
    notes: 'Notes ({n})', more: '… and {n} more', start: 'Import {n} layers', uploading: 'Uploading {done} of {total}…',
    done: 'Imported {n} images (rev {rev}).', failed: 'The import stopped after {done} of {total} uploads.',
    retry: 'Retry the rest', close: 'Close',
    nextAutorig: 'Next: open the {panel} panel and run “{action}” to build the bones, slots and regions from these layers.',
  },
  autorig: {
    title: 'Auto-rig', status: '{images} images · {placed} placed by a PSD · {slots} slots',
    groupRig: 'Whole rig', groupSkeleton: 'Skeleton', groupParts: 'Parts', groupAnimate: 'Animation',
    fn: {
      autoRig: 'Auto-rig everything', suggestSkeleton: 'Suggest skeleton', detectJoints: 'Detect joints',
      inferDrawOrder: 'Infer draw order', suggestIk: 'Suggest IK', checkMirrorAsymmetry: 'Check mirror asymmetry',
      autoMesh: 'Auto mesh', autoWeights: 'Auto weights', suggestHandle: 'Suggest handle', suggestGrip: 'Suggest grip',
      walkCycle: 'Walk cycle',
    },
    arg: {
      images: 'Images (none = all)', attachment: 'Attachment', bone: 'Bone', bones: 'Bones (none = default)',
      jointHints: 'Joint hints (bones)', facing: 'Facing', method: 'Weights method', detail: 'Mesh detail',
      pairs: 'Joint pairs from the selected bones: {n} (none = every pair)', choose: '(choose)', auto: 'Automatic',
      left: 'Left', right: 'Right', front: 'Front', heat: 'Bone heat', envelope: 'Envelope',
      animation: 'Animation name (empty = walk)', frames: 'Frames in the loop', limbs: 'Limbs (bones; none = found by name)',
    },
    analyse: 'Analyse', running: 'Analysing ({fn})…', failed: 'The analysis failed.',
    ready: 'Plan ready: {commands} commands, confidence {percent} %.',
    applied: 'Applied as rev {rev} (confidence {percent} %).', undone: 'Rev {rev} was undone.',
    stale: 'The project changed since this plan was made (rev {ifRev}, now {currentRev}). Analyse again to plan on the current rig.',
    reviewTitle: 'Review: {fn}', confidence: 'Confidence {percent} % ({band})',
    band: { low: 'low', medium: 'medium', high: 'high' },
    commands: 'Proposed commands ({n})', warnings: 'Notes and warnings ({n})', empty: 'This analysis proposes no change.',
    rerig: 'This project already has a rig ({slots} slots): Apply changes {n} of its existing values (the ghost shows them; Undo brings them back).',
    zeroConfidence: 'Confidence is 0 %: at least one step found nothing it trusts. Check the commands and the ghost before you apply, or analyse again with other options.',
    ghost: 'Show the ghost in the viewport',
    ghostTooLarge: 'No ghost: {n} commands is more than the preview handles ({max}); Apply still works.',
    ghostFailed: 'No ghost: the plan does not apply to the open document.',
    ghostOutOfSync: 'No ghost: the open document is not at the rev this plan was made on. Analyse again to see it.',
    apply: 'Apply (one commit)', rerun: 'Analyse again', close: 'Close',
    pivots: 'Pivot hints in layer pixels (empty = automatic)', pivotSet: 'Set', pivotClear: 'Clear',
    pivotX: 'x', pivotY: 'y', pivotAuto: 'automatic', rerunWithPivots: 'Analyse again with the hints',
  },
} as const;
